import React from 'react';

// Material UI Components
import {Tooltip, Button} from '@material-ui/core';

// Icons
import FormatBoldIcon from '@material-ui/icons/FormatBold';
import FormatItalicIcon from '@material-ui/icons/FormatItalic';
import FormatUnderlinedIcon from '@material-ui/icons/FormatUnderlined';
import FormatStrikethroughIcon from '@material-ui/icons/FormatStrikethrough';
import FormatSizeIcon from '@material-ui/icons/FormatSize';

export default function Formats( {StyleButton, currentSelectionOffset, contentBlock, onClickToggleStyle} ) {
    const types = ["BOLD", "ITALIC", "UNDERLINE", "STRIKETHROUGH", "UPPERCASE"];
    const stylesArray = [...contentBlock.getInlineStyleAt(currentSelectionOffset)]

    let [boldActive] = React.useState(false);
    let [italicActive] = React.useState(false);
    let [underlineActive] = React.useState(false);
    let [strikethroughActive] = React.useState(false);
    let [uppercaseActive] = React.useState(false);

    // This function will check whether the cursor is currently on an inline style if so it will set the activeFormat to either true or false
    const checkStyle = (style) => {
        switch(style){
            case "BOLD":
                boldActive = !boldActive;
                break;
            case "ITALIC":
                italicActive = !italicActive;
                break;
            case "UNDERLINE":
                underlineActive = !underlineActive;
                break;
            case "STRIKETHROUGH":
                strikethroughActive = !strikethroughActive;
                break;
            case "UPPERCASE":
                uppercaseActive = !uppercaseActive;
                break;
            default:
                break;
        }
    }
    
    // Will loop through the types array and will execute the checkStyle function to check whether the cursor is on the style
    for (const format of types) {
        const formatStyle = stylesArray.find(item => item === format);

        checkStyle(formatStyle);
    }

    return (
        <React.Fragment>
            {
                types.map((item, index) => {
                    let currentFormat;
                    
                    if(item === "BOLD"){
                        currentFormat = boldActive
                    }
                    if(item === "ITALIC"){
                        currentFormat = italicActive
                    }
                    if(item === "UNDERLINE"){
                        currentFormat = underlineActive
                    }
                    if(item === "STRIKETHROUGH"){
                        currentFormat = strikethroughActive
                    }
                    if(item === "UPPERCASE"){
                        currentFormat = uppercaseActive
                    }

                    return(
                        <div key={index} onMouseDown={(event) => {
                            event.preventDefault();

                            if(currentFormat === false){
                                checkStyle(item)
                                onClickToggleStyle(item)
                            }else{
                                onClickToggleStyle(item)
                            }
                        }}>
                            <Tooltip title={item} placement="bottom">
                                <Button 
                                    aria-label={item} 
                                    className={StyleButton} 
                                    color={(currentFormat === true) ? "primary" : "inherit"} 
                                    size="large" 
                                    variant={(currentFormat === true) ? "contained" : "text"}>
                                    {
                                        item === "BOLD" ? <FormatBoldIcon />
                                            : item === "ITALIC" ? <FormatItalicIcon />
                                                : item === "UNDERLINE" ? <FormatUnderlinedIcon />
                                                    : item === "STRIKETHROUGH" ? <FormatStrikethroughIcon />
                                                        : item === "UPPERCASE" ? <FormatSizeIcon />
                                                            : ""
                                    }
                                </Button  >
                            </Tooltip>
                        </div>
                    );
                })
            }
        </React.Fragment>
    )
}